module.exports = __webpack_public_path__ + "media/promo/promo/images/chief-glow-2-771c9918c23259acbb70e87c8e3d69e3.png";